import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as e from "react";
import { getSortedFormFields as t } from "@aws-amplify/ui";
import { FormField as r } from "./FormField.js";
import { useAuthenticator as o } from "../hooks/useAuthenticator/index.js";

function m() {
  var _o = o(function (_ref) {
    var e = _ref.route;
    return [e];
  }),
      m = _o._state,
      a = _o.route,
      n = e.useRef(t(a, m).flatMap(function (_ref2, m) {
    var _ref3 = _slicedToArray(_ref2, 2),
        t = _ref3[0],
        o = _ref3[1];

    return e.createElement(r, Object.assign({
      key: m,
      name: t
    }, o));
  })).current;

  return e.createElement(e.Fragment, null, n);
}

export { m as FormFields };